module.exports = __webpack_public_path__ + "media/images/404-84e117032d2b040ce9835ab29e6e281f.svg";